import { Box, Grid, Typography, useTheme } from "@mui/material";
import LoginImage from "../../../../../media/images/LoginImage.png";
import { useAppSelector } from "../../../../../hooks/useRedux";
import MobileHeader from "../../../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../../../layout/AuthLayout/Footer";
import DriverSignup from "../DriverSignup";
import LogoImage from "../../../../../media/images/icons/logo.svg";
import LoginLink from "../LoginLink";
import OwnerIndividualSignup from "../OwnerSignup/Individual";
import OwnerLegalEntitySignup from "../OwnerSignup/LegalEntity";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import { useNavigate } from "react-router-dom";
import ChannelLinks from "../../../../components/ChannelLinks";

export default function UserSignupGrid() {
  const theme = useTheme();
  const { userSignupTab, ownerTypeRegister } = useAppSelector(
    (state) => state.settings
  );
  const roleTitle =
    userSignupTab === "drivers" ? "ثبت‌نام راننده" : "ثبت‌نام صاحب کالا";

  const navigate = useNavigate();

  return (
    <>
      <MobileHeader>
        <Box
          sx={{
            display: "flex",
            marginRight: "3px",
          }}
        >
          <Typography
            noWrap
            onClick={() => navigate("/")}
            sx={{
              cursor: "pointer",
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "12px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={12} />
          <Typography
            noWrap
            sx={{
              color: "secondary.main",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {roleTitle}
          </Typography>
        </Box>
      </MobileHeader>
      <Box>
        <Grid
          container
          sx={{
            height: "100%",
            overflowY: "hidden",
          }}
        >
          <Grid
            sx={{
              height: "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: "12px",
              paddingX: {
                xs: "8px",
              },
            }}
            xs
            sm
            md={12}
            lg={12}
            item
          >
            <Box
              sx={{
                width: "100%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  marginX: "auto",
                  width: {
                    // xl: "40%",
                    // lg: "60%",
                    // md: "80%",
                    xs: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    mb: "16px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: {
                      xs: "flex",
                      md: "none",
                    },
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                    color={"primary.main"}
                  >
                    {roleTitle}
                  </Typography>
                </Box>
                {userSignupTab === "drivers" ? (
                  <DriverSignup />
                ) : ownerTypeRegister === "individual" ? (
                  <OwnerIndividualSignup />
                ) : (
                  <OwnerLegalEntitySignup />
                )}

                <LoginLink />
                <ChannelLinks />
              </Box>
            </Box>
            {/* <AuthFooter /> */}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              // border: "5px solid gray",
              backgroundImage: `url(${LoginImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              display: {
                xs: "none",
                // md: "flex",
              },
              alignItems: "center",
              justifyContent: "center",
              backgroundPosition: "20%",
            }}
          >
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                paddingY: "16px",
                paddingX: "10px",
                position: "relative",
                maxWidth: {
                  xl: "45%",
                  lg: "65%",
                  md: "80%",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "background.default",
                  opacity: "0.9",
                  borderRadius: "16px",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <img width={70} src={LogoImage} alt="" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <AuthFooter />
    </>
  );
}
